export const GET_CODETABLE_DATA = 'GET_CODETABLE_RESULT_DETAILS';
export const POST_CODETABLE_DATA = 'POST_CODETABLE_RESULT_DETAILS';
export const GET_CONTACT_DETAILS = 'GET_CONTACT_DETAILS';
export const GET_CLIENT_DETAILS = 'GET_CLIENT_DETAILS';
export const CLIENT_SEARCH_DATA_ACTION_TYPES =
  'CLIENT_SEARCH_DATA_ACTION_TYPES';
export const SET_TAB_VALUE = 'SET_TAB_VALUE';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_REDUX_DATA_SEARCH_SCREEN = 'SET_REDUX_DATA_SEARCH_SCREEN';
export const SET_CLEAR_REDUX_DATA_CLINT = 'SET_CLEAR_REDUX_DATA_CLINT';
